import { Link } from "supercell-frontend-base/src/components/article/navigation/link";

import { getArticleIndex } from "supercell-frontend-base/src/utils/articles/get-article-index";
import { filterEntry } from "supercell-frontend-base/src/targeting/targeting";
import { RogueGameParams } from "../../validation/game-params";
import { isOnNewsTab } from "supercell-frontend-base/src/utils/articles/is-on-tab";

export const getProps =
    (id: string, isolated: boolean, gameParams: RogueGameParams) =>
    ({ articles, globals }) => {
        const newsArticles = articles.filter(isOnNewsTab);

        const validArticles = newsArticles.filter((e) =>
            filterEntry(e, gameParams),
        );

        const index = getArticleIndex(validArticles, id);
        const article = validArticles[index];

        const nextPrevArticles = validArticles.filter(
            (e) => e.showInNewsFeed !== "HIDE_IN_NEWS_FEED",
        );
        const nextPrevArticlesIndex = getArticleIndex(nextPrevArticles, id);
        const prevArticle = nextPrevArticles[nextPrevArticlesIndex - 1];
        const nextArticle =
            nextPrevArticlesIndex > -1 &&
            nextPrevArticles[nextPrevArticlesIndex + 1];

        const prevLinkProps = !isolated
            ? {
                  disabled: !nextArticle,
                  label: globals["globalText.langOlder"],
                  labelComponentProps: {
                      data: nextArticle,
                  },
              }
            : undefined;

        const nextLinkProps = !isolated
            ? {
                  disabled: !prevArticle,
                  label: globals["globalText.langNewer"],
                  labelComponentProps: {
                      data: prevArticle,
                  },
                  next: true,
              }
            : undefined;

        return {
            article,
            Link,
            prevLinkProps,
            nextLinkProps,
        };
    };
